import { BigDataEventConstants } from "./constants/big-data-constants";
import { BigDataObjectConstants } from "./constants/big-data-object-constants";
import { CappingConstants } from "./constants/capping-constants";
import { AllowedURLParamTypes } from "./custom-types/custom-types";
import { Attribute, BigDataHelper } from "./helpers/big-data-helper";
import { Http } from "./http/http";
import { HttpHeaders } from "./http/sub-types/http-headers";
import { BigData } from "./marketing-client-bigdata";
import { CollectionIdsObject, Utils } from "./utils/utils";

export class Capping {
  guid: string;

  constructor(private http: Http) { }

  setGUID(guid: string): void {
    this.guid = guid;
  }

  sendCapping(data: CappingData, display = false): Promise<any> {
    const visitId: string = Utils.getBigDataVariable(
      BigDataObjectConstants.visitIdCookie,
      BigDataObjectConstants.visitIdBigData
    ),
      pageViewId: string = Utils.getBigDataVariable(
        BigDataObjectConstants.pageViewCookie,
        BigDataObjectConstants.pageViewBigData
      ),
      isHarmonyTest: AllowedURLParamTypes = Utils.getURLParamsAsObject().enableHarmonyTest,
      url = isHarmonyTest ? process.env["HARMONY_TEST_URL"] : process.env["MARKETING_PROXY_URL"],
      endPath = display ? CappingConstants.displayPath : CappingConstants.registerPath,
      headers: HttpHeaders = { "Content-Type": "application/json" };

    data.visitId = visitId;
    data.pageViewId = pageViewId;
    data.guid = this.guid;

    return this.http
      .put({
        url: `${url}${endPath}`,
        headers,
        data: data
      });
  }

  sendCappingEvent(element: Element, onDisplay = false) {
    const eventName = onDisplay ? BigDataEventConstants.onDisplay : BigDataEventConstants.onLoad,
          attribute: Attribute = BigDataHelper.createAttribute(element),
          {campaignId, actionId, touchPointId} = attribute,
          collectionIdsObject: CollectionIdsObject = {campaignId, actionId, touchPointId} || {};

    this.sendCapping(collectionIdsObject as CappingData, onDisplay);
    BigData.sendDataOceanEvent(eventName, attribute);
  }
}

export interface CappingData {
  campaignId: string;
  actionId: string;
  touchPointId: string;
  guid?: string;
  visitId?: string;
  pageViewId?: string;
}
